// extracted by css-extract-rspack-plugin
export default {"button":"Yn6Ky","inner":"IWbR6","example":"g1IYV","content":"jHeKP","label":"S1_cc"};